import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { Hospital, HospitalFormPayload } from '../../types/hospital'

export const hospitalService = {
  async list(params?: {
    with_trashed?: boolean
    only_trashed?: boolean
    is_active?: boolean
    search?: string
    page?: number
    per_page?: number
  }) {
    const { data } = await apiClient.get<ApiPaginatedResponse<Hospital> | ApiSuccessResponse<Hospital[]>>(
      '/hospitals',
      { params },
    )
    return data
  },

  async create(payload: HospitalFormPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<Hospital>>('/hospitals', payload)
    return data
  },

  async update(id: string, payload: HospitalFormPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<Hospital>>(`/hospitals/${id}`, payload)
    return data
  },

  async remove(id: string) {
    const { data } = await apiClient.delete<ApiSuccessResponse<null>>(`/hospitals/${id}`)
    return data
  },

  async restore(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Hospital>>(`/hospitals/${id}/restore`)
    return data
  },
}
